import React from 'react';
import { Pane, Flex, Text } from '@leverege/ui-elements';
import { Attributes } from '@leverege/ui-attributes';
import Constants from '../../../views/salesFlow/Constants';
import { jsx as _jsx } from "react/jsx-runtime";
const ALERT_LABELS = {
  locator: 'Locator',
  tags1: 'Tags (1)',
  tags2: 'Tags (2)',
  tags3: 'Tags (3)',
  tags4: 'Tags (4)',
  tagsUnknown: 'Tags'
};
const ALERT_VARIANTS = {
  locator: 'pillLocator',
  tags1: 'pillTag',
  tags2: 'pillTag',
  tags3: 'pillTag',
  tags4: 'pillTag',
  tagsUnknown: 'pillTag'
};
export default function RecovrProductsSold(props) {
  const {
    value,
    original
  } = props;
  const saleType = Attributes.get('sale.type', 'sale', original?.data);
  if (saleType !== Constants.SALE_TYPES.VEHICLE_WITH_LOCATOR) {
    return null;
  }
  const alerts = [];
  const locator = value?.includes('Locator');
  const keys = value?.includes('Tags');
  if (locator || !locator && !keys) {
    alerts.push('locator');
  }
  if (keys) {
    const keysCount = Attributes.get('sale.keysCount', 'sale', original?.data);
    const val = `tags${keysCount}`;
    if (ALERT_LABELS[val]) {
      alerts.push(val);
    } else {
      alerts.push('tagsUnknown');
    }
  }
  return /*#__PURE__*/_jsx(Pane, {
    variant: "tableCellContent",
    children: /*#__PURE__*/_jsx(Flex, {
      variant: "rowM",
      children: alerts.map(a => /*#__PURE__*/_jsx(Text, {
        variant: ALERT_VARIANTS[a] || 'pill',
        children: ALERT_LABELS[a]
      }, a))
    })
  });
}